import Vue from 'vue';

const success = (response, context) => {
  context.get_custom_short_codes(context);
  context.closeModal('#new-custom-short-code-modal');
  toastr.success(response.data.msg);
  context.resetCustomShortCodeData();
  context.smallLoading = false;
};

const failed = (error, context) => {
  context.loading = false;
  context.smallLoading = false;
  if (error.response && error.response.data && error.response.data.msg) {
    if (typeof (error.response.data.msg) == 'object') {
      let errors = Object.values(error.response.data.msg);
      for(let error of errors) {
        toastr.error(error);
      }
    } else {
      toastr.error(error.response.data.msg);
    }
  }
};

export default (context, shortCode) => {
  context.smallLoading = true;
  return Vue.$http.put('/custom-short-codes/' + shortCode.id, shortCode).then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/automation/updateCustomShortCode.js